<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-4"
                         :key="objectKey + '-header'">
                        <span class="h3 mb-2 mb-lg-0" v-if="!object.id">Муниципалитет</span>
                        <span class="h3 mb-2 mb-lg-0 mr-3" v-else>{{ header }}</span>
                        <sup><small v-if="!object.id" class="text-secondary ml-2">Новый</small></sup>
                    </div>
                </div>
            </div>

            <div id="form" class="d-flex flex-wrap">

                <form-field  class="col-xs-12 col-lg-10 required mb-2"
                             :label="getFieldLabel('name')"
                             :editable="getAbility('name')"
                             :value="object.name"
                             :feedback="liveFeedback('name')">
                    <template #field>
                        <b-form-input
                            id="name"
                            class="w-100"
                            type="text"
                            v-model="$v.form.name.$model"
                            :state="validateState('name')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-5 required mb-2"
                             :label="getFieldLabel('shortName')"
                             :editable="getAbility('shortName')"
                             :value="object.shortName"
                             :feedback="liveFeedback('shortName')">
                    <template #field>
                        <b-form-input
                            id="shortName"
                            class="w-100"
                            type="text"
                            v-model="$v.form.shortName.$model"
                            :state="validateState('shortName')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field :label="getFieldLabel('parent')"
                            class="col-xs-12 col-lg-5 mb-2"
                            :editable="getAbility('parent')"
                            :feedback="liveFeedback('parent')"
                            :value="object.parent"
                            :key="objectKey + 'parent'">
                    <template #field>
                        <single-select name="parent"
                               v-model="form['parentObject']"
                               :url="getMunicipalitiesUrl"
                               :label="getFieldLabel('parent')"
                               label-key="short_name"
                               :clearable="true"
                               :state="getValidationClass('parent')"
                               v-on:select-changed="onModelObjectSingleSelectChanged"
                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                    </template>
                </form-field>

                <form-field class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-1"
                           :label="getFieldLabel('listOrder')"
                           :editable="getAbility('listOrder')"
                           :value="getObjectField('listOrder')"
                           :feedback="liveFeedback('listOrder')">
                  <template #field>
                      <b-form-input
                          id="listOrder"
                          class="w-100"
                          type="number"
                          v-model="$v.form.listOrder.$model"
                          :state="validateState('listOrder')">
                      </b-form-input>
                  </template>
                </form-field>

                <form-field :label="getFieldLabel('eliminated')"
                            class="col-xs-12 col-sm-8 col-md-4 col-lg-3"
                            :value="object.eliminated"
                            :editable="getAbility('eliminated')"
                            :feedback="liveFeedback('eliminated')">
                    <template #value>
                            <span v-if="object.eliminated">Да</span>
                            <span v-else>Нет</span>
                    </template>
                    <template #field>
                        <b-form-checkbox  size="lg" v-model="form.eliminated" @change="onEliminatedChange" switch >
                            <span v-if="form.eliminated">Да</span>
                            <span v-else>Нет</span>
                        </b-form-checkbox>
                    </template>
                </form-field>
            </div>

            <object-form-buttons :has-changes="hasChanges"
                 :object-exists="Boolean(object.id)"
                 @object-create="onCreate"
                 @object-update="updateObject"
                 @object-cancel-changes="cancelChanges" class="mb-5"/>

        </b-card>

        <stub :failed-loading="failedLoading" v-else />

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>
    </div>
</template>

<script>
    import {ObjectComponentMixin} from "../../../../components/Forms/ObjectComponentMixin";
    import FormField from "../../../../components/Forms/FormField";
    import ObjectFormButtons from "../../../../components/Forms/ObjectFormButtons";
    import ConfirmLeaveModal from "../../../../components/Forms/ConfirmLeaveModal";
    import api from "../../../../api";
    import {Municipality} from "./municipality";
    import SingleSelect from "@/components/Select/SingleSelect";
    import Stub from "@/components/Stub.vue";

    export default {
        name: "MunicipalityDetail",
        components: {
            Stub,
            SingleSelect,
            FormField,
            ObjectFormButtons,
            ConfirmLeaveModal
        },
        mixins: [ ObjectComponentMixin ],
        props: {
            municipalityId: null
        },
        data() {
            return {}
        },
        computed: {
            getMunicipalitiesUrl() {
                return api.municipalities.default.list()
            }
        },
        methods: {
            onEliminatedChange() {
                this.$v.form.eliminated.$touch();
            }
        },
        beforeMount() {
            this.objectClass = Municipality;
            this.objectId = this.municipalityId ? this.municipalityId : this.$route.params.id;
            this.apiEntryPoint = api.municipalities;
            this.backRoute = 'municipalityList';
            this.nextRoute = 'municipalityDetail';
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },
    }
</script>

<style scoped>

</style>